import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Danhmucloaihinhptvantai from "components/Danhmuc/Phanloaivantai/Danhmucloaihinhptvantai.js";
import Danhmucphanloaivantai from "components/Danhmuc/Phanloaivantai/Danhmucphanloaivantai.js";
import Danhmuctuyenvantai from "components/Danhmuc/Phanloaivantai/Danhmuctuyenvantai.js";
import Danhmucphanloaiphuongtien from "components/Danhmuc/Loaiphuongtien/Danhmucphanloaiphuongtien.js";
import Danhmucphannhomphuongtien from "components/Danhmuc/Loaiphuongtien/Danhmucphannhomphuongtien.js";
import Danhmucloaidonvi from "components/Danhmuc/Donvi/Danhmucloaidonvi.js";
import Danhmuctinhthanh from "components/Danhmuc/Donvi/Danhmuctinhthanh.js";
export default function DMdungchung() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Loại hình phương tiện vận tải",
            tabContent: <Danhmucloaihinhptvantai />,
          },
          {
            tabName: "Phân loại vận tải",
            tabContent: <Danhmucphanloaivantai />,
          },
          {
            tabName: "Tuyến vận tải",
            tabContent: <Danhmuctuyenvantai />,
          },
          {
            tabName: "Phân loại phương tiện",
            tabContent: <Danhmucphanloaiphuongtien />,
          },
          {
            tabName: "Phân nhóm phương tiện",
            tabContent: <Danhmucphannhomphuongtien />,
          },
          {
            tabName: "Loại đơn vị",
            tabContent: <Danhmucloaidonvi />,
          },
          {
            tabName: "Đơn vị hành chính",
            tabContent: <Danhmuctinhthanh />,
          },
        ]}
      />
    </div>
  );
}
